import { mandatoryFieldValditor, pinCodeValidator } from "../../../../common/utils/validator";
import {  addresses, ADDRESS_TYPE_ENUM, formElement } from "../summary.constant";

export const addressSchema = {
    pinCode: {...formElement, validator: pinCodeValidator}, 
    address: {...formElement, validator: mandatoryFieldValditor}, 
    city: {...formElement}
};

export const formSchema = {
        selected: { id: ADDRESS_TYPE_ENUM.EXISTINGADDRESS, displayName: "Existing Addresses" },
        ...addressSchema,
        officeName: '',
        installationAddress: {},
        existingAddress: { displayName: "Same as Billing address", key: "billingAddress" }
};


export const getDefaultValue =  (order) => {
    const {lead: {customer: {authorizedSignatory: {address, companyName}}}} = order;
    const installationAddress = {...address, pinCode: address.pincode, officeName: companyName}
    formSchema['installationAddress'] = installationAddress;
    formSchema['officeName'] = companyName;
    return formSchema;
}
